export interface IItemDefaults {
  id?: string;
  referenceCode: string;
  description: string;
  unitPrice: number | null;
  quantity: number;
  vat: number | null;
  vatPercentage: number;
  dto: number | null;
  dtoType: 'amount' | 'percentage';
  deliveryNote: string;
  poNumber: string;
  taxId: string | null;
  taxType: string;
  isDiscountVisible?: boolean;
}

export const defaultItemValues: IItemDefaults = {
  deliveryNote: "",
  description: "",
  dto: null,
  dtoType: 'amount',
  isDiscountVisible: false,
  poNumber: "",
  quantity: 0,
  referenceCode: "",
  taxId: "",
  taxType: "",
  unitPrice: null,
  vat: 0,
  vatPercentage: 0,
  id: "",
};
